/**
 * @description pastilles sur les événements + resize des événements sans images
 */

/* global Drupal drupalSettings jQuery ModuloTS */

(function ($, Drupal, drupalSettings) {
	'use strict';

	Drupal.behaviors.eventsFollowLove = {
		attach: function (context, drupalSettings) {
			const buttonLove = `<div class="status status--love"><div><i data-icon="heart"></i><span>${ModuloTS.Like}</span></div></div>`;
			const buttonFollow = `<div class="status status--follow"><div><i data-icon="pin"></i><span>${ModuloTS.Pin}</span></div></div>`;
			const endEvent = `<div class="end-event"></div>`;
			const isLove = 'div.is-love';
			const isFollow = 'div.is-sticky';

			// FUNCTION
			const insertLabel = ($selector, $element, $placement) => {
				document.querySelectorAll($selector).forEach((element) => {
					element.insertAdjacentHTML($placement, $element);
				});
				document.querySelectorAll('div').forEach((div) => {
					if (div.innerText === 'Dates') {
						div.remove();
					}
				});
			};
			const agendaItemSize = () => {
				document
					.querySelectorAll('div.list-agenda__item')
					.forEach((el) => {
						const img = el.querySelectorAll(
							'div.list-agenda__item__content__img'
						);

						if (img.length === 0) {
							el.classList.add('little-item');
						}
					});
			};

			// GO 🚀

			insertLabel(isFollow, buttonFollow, 'afterbegin');
			insertLabel(isLove, buttonLove, 'afterbegin');
			insertLabel('div.rt__grid  ', endEvent, 'beforeend');
			agendaItemSize();
			document
				.querySelectorAll('.list-agenda__item__content')
				.forEach((status) => {
					if (
						status.querySelector('.status--follow') &&
						status.querySelector('.status--love')
					) {
						status.querySelector('.status--love').remove();
					}
				});
		},
	};
})(jQuery, Drupal, drupalSettings);
